import React from 'react'
import { getClassNameModern } from '../../../../../../Shared/Frontend/utils/getClassNameFromStyle'
import { BGColors } from '../../modernBlocks.state'
import type { ActionProps } from '../../modernBlocks.state'
import { SharedBlockLayout } from '../shared/sharedBlock.layout'
import type { HighlightBlockClassNames } from './highlightBlock.state'
import { fixTableStructure, htmlDecode } from '../../../utils/html'
import { slugify } from '../../../../../../Shared/Frontend/utils/slugify'

export const highlightBlockClasses: HighlightBlockClassNames = {
  // DEFAULTS
  block: 'block block--text block--highlight',
  inview: 'inview',
  inner: 'block__inner ls-container ls-gutter ls-spacing--s',
  header: 'block__header',
  label: 'block__label text--s',
  title: 'block__title title--m',
  intro: 'block__intro text--l',
  content: 'block__content',
  text: 'block__text text--styled',
  footer: 'block__footer ls-clickables',
  clickableWrapper: 'block__action ls-clickable',
  clickablePrimary: 'block__button button button--primary',
  clickableSecondary: 'block__button button button--secondary',

  // BLOCK SPECIFIC
  layout: 'block__layout',
  layoutInner: 'block__layout-inner ls-gutter ls-spacing',
  clickableTertiary: 'block__button button button--tertiary',
}

export const HighlightBlockLayout = {
  ColorSchemeClassName: (bgColour?: BGColors) => {
    let colorScheme: string = `highlight--${bgColour}`
    return colorScheme
  },
  Inner: (props: { id?: string; children?: React.ReactNode; amountNested: number }): JSX.Element => {
    const { amountNested, children, id } = props
    return (
      <div className={getClassNameModern(highlightBlockClasses, 'inner', 'mw-container-s mx-auto px-gutter')}>
        <div className={getClassNameModern(highlightBlockClasses, 'layout', '')}>
          <div className={getClassNameModern(highlightBlockClasses, 'layoutInner', '')}>{children}</div>
        </div>
      </div>
    )
  },
  Content: (
    props: {
      label?: string
      title?: string
      intro?: string
      text: string
      showActionAsLink: boolean
      bgColour?: BGColors
    } & ActionProps
  ) => {
    const { label, title, intro, text, showPrimary, showSecondary, primaryAction, secondaryAction, showActionAsLink } =
      props
    return (
      <>
        {(label || title || intro) && (
          <header className={getClassNameModern(highlightBlockClasses, 'header', '')}>
            {label && (
              <p className={getClassNameModern(highlightBlockClasses, 'label', 'fs-6 text-primary text-uppercase')}>
                {label}
              </p>
            )}
            {title && <h2 id={slugify(htmlDecode(title))} className={getClassNameModern(highlightBlockClasses, 'title', 'h2 mb-3')}>{title}</h2>}
            {intro && (
              <div
                className={getClassNameModern(highlightBlockClasses, 'intro', 'text--styled lead mb-3')}
                dangerouslySetInnerHTML={{ __html: intro }}
              />
            )}
          </header>
        )}
        {text && (
          <div className={getClassNameModern(highlightBlockClasses, 'content', '')}>
            <div
              className={getClassNameModern(highlightBlockClasses, 'text', 'text--styled')}
              dangerouslySetInnerHTML={{ __html: fixTableStructure(text) }}
            />
          </div>
        )}
        {(showPrimary || showSecondary) && (
          <footer className={getClassNameModern(highlightBlockClasses, 'footer', 'pt-5')}>
            {showPrimary && primaryAction && primaryAction.title && primaryAction.url && (
              <div
                className={getClassNameModern(highlightBlockClasses, 'clickableWrapper', 'd-block d-sm-inline-block')}
              >
                <SharedBlockLayout.Clickable
                  id="textPrimaryAction"
                  type="button"
                  link={primaryAction}
                  classNames={`${getClassNameModern(
                    highlightBlockClasses,
                    showActionAsLink === true
                      ? props.bgColour == 'red' || props.bgColour == 'darkred'
                        ? 'clickableSecondary'
                        : 'clickableTertiary'
                      : 'clickablePrimary',
                    'btn btn-primary'
                  )} ${
                    props.bgColour == 'darkred' ? 'button--on-darkred' : props.bgColour == 'red' ? 'button--on-red' : ''
                  }`}
                />
              </div>
            )}
            {showSecondary && secondaryAction && secondaryAction.title && secondaryAction.url && (
              <div
                className={getClassNameModern(
                  highlightBlockClasses,
                  'clickableWrapper',
                  'd-block d-sm-inline-block ms-sm-3 mt-3 mt-sm-0'
                )}
              >
                <SharedBlockLayout.Clickable
                  id="textSecondaryAction"
                  type="button"
                  link={secondaryAction}
                  classNames={`${getClassNameModern(
                    highlightBlockClasses,
                    props.bgColour == 'darkred' || props.bgColour == 'red' ? 'clickableSecondary' : 'clickableTertiary',
                    'btn btn-outline-primary'
                  )} ${
                    props.bgColour == 'darkred' ? 'button--on-darkred' : props.bgColour == 'red' ? 'button--on-red' : ''
                  }`}
                />
              </div>
            )}
          </footer>
        )}
      </>
    )
  },
}
